import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

const BASE = `${Config.nodeSiteUrl}v1/proctoring-admin`;

const ProctoringAdminService = {
  getLiveSessions: (): Promise<any> => myAxios.get(`${BASE}/live-sessions`),

  getSessions: (params: Record<string, string | number>): Promise<any> => {
    const qs = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null && String(value) !== "") {
        qs.set(key, String(value));
      }
    }
    return myAxios.get(`${BASE}/sessions?${qs.toString()}`);
  },

  getSessionDetail: (testId: number, enquiryId: number): Promise<any> =>
    myAxios.get(`${BASE}/session-detail?testId=${testId}&enquiryId=${enquiryId}`),

  reviewSession: (body: {
    testId: number;
    enquiryId: number;
    reviewStatus: string;
    notes: string;
  }): Promise<any> => myAxios.post(`${BASE}/review-session`, body),

  blockStudent: (body: { testId: number; enquiryId: number; reason: string }): Promise<any> =>
    myAxios.post(`${BASE}/block-student`, body),

  unblockStudent: (body: { testId: number; enquiryId: number; reason?: string }): Promise<any> =>
    myAxios.post(`${BASE}/unblock-student`, body),

  getBlocks: (testId?: number): Promise<any> =>
    myAxios.get(`${BASE}/blocks${testId ? `?testId=${testId}` : ""}`),

  getWebcamRoster: (testId: number): Promise<any> =>
    myAxios.get(`${BASE}/webcam-roster?testId=${testId}`),
};

export default ProctoringAdminService;
